export const USER_ROLES = {
  admin: "01549060-1c43-4884-ba26-961f88f7482e",
  supervisor: "ae112981-5b59-418a-84cb-a71c0baec338",
  operator: "bdfa1e62-f284-4a7b-81de-34d627b4abe9",
};
